import React from 'react';
import { useLocation } from 'react-use';

import { useTranslation } from '../../hooks/useTranslation';
import AuthenticatedApp from './authenticatedApp/AuthenticatedApp';
import LegacyApp from './legacyApp/LegacyApp';

export interface AppProps {}

export function App({}: AppProps): JSX.Element {
  const { pathname } = useLocation();
  useTranslation();

  if (
    pathname === '/credit/' ||
    pathname === '/credit/summary' ||
    pathname === '/credit/documents' ||
    pathname === '/credit/communication'
  ) {
    return <LegacyApp />;
  }

  return <AuthenticatedApp />;
}
